import { render, staticRenderFns } from "./services-offered-display.vue?vue&type=template&id=4e920f68&scoped=true&"
var script = {}
import style0 from "../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css?vue&type=style&index=0&id=4e920f68&scoped=true&lang=css&"
import style1 from "./services-offered-display.vue?vue&type=style&index=1&id=4e920f68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e920f68",
  null
  
)

export default component.exports